import React, {useEffect, useMemo} from "react";
import {IDashboardAggregatorDevices, IDashboardAggregatorNotes} from "./DashboardTypes";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import {FaRegCircleCheck, FaRegCircleXmark} from "react-icons/fa6";

interface DevicesCardProps {
    devices: IDashboardAggregatorDevices[]
}

export const DevicesCard : React.FC<DevicesCardProps> = ({devices, }) =>  {

    useEffect(() => {
        console.log('devices', devices)
    }, []);

    const columns: GridColDef<IDashboardAggregatorDevices>[] = useMemo(() => [
        // { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'name',
            headerName: 'Text',
            width: 600,
            editable: false,
        },
        {
            field: 'isPredefined',
            headerName: 'Gerät vorhanden?',
            width: 150,
            align: 'center',
            renderCell: params => {
                if(params.row.isPredefined) {
                    return <FaRegCircleCheck style={{fontSize: '30px', color: 'green'}} />
                } else {
                    return  <FaRegCircleXmark style={{fontSize: '30px', color: 'red'}} />;
                }
            },
            editable: false,
        },
        {
            field: 'count',
            headerName: 'Anzahl',
            width: 150,
            editable: false,
        }
    ], []);


    return (
        <>
            <DataGrid getRowId={row => row.name}
                      columns={columns}
                      rows={devices}
                      density={'compact'}
                      initialState={{
                          sorting: {
                              sortModel: [{ field: 'count', sort: 'desc' }],
                          },
                      }}
                      sx={{
                          "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: "#fff",
                              color: "#000",

                              fontSize: 14,
                              fontWeight: '500 !!!important',
                              '--unstable_DataGrid-headWeight': 600
                          },
                      }}
            >
            </DataGrid>
        </>
    );
}